export default __webpack_public_path__ + "static/farrer-park-hospital-e986bb2011501ba2cf942e1644562313.png";